import { useEffect, useState } from "react";
import { api, fileUrl, formatBRL } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Plus, Pencil, Trash2 } from "lucide-react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";

export default function AdminProducts() {
  const [prods, setProds] = useState([]);
  const [del, setDel] = useState(null);

  const load = () => api.get("/admin/products").then((r) => setProds(r.data || []));
  useEffect(() => { load(); }, []);

  const doDelete = async () => {
    try {
      await api.delete(`/admin/products/${del.id}`);
      toast.success("Produto excluído");
      setDel(null);
      load();
    } catch (e) {
      toast.error("Erro ao excluir");
    }
  };

  return (
    <div>
      <div className="flex items-start justify-between mb-8 flex-wrap gap-3">
        <div>
          <div className="overline-label">Catálogo</div>
          <h1 className="font-display text-4xl text-white tracking-tighter mt-3">Produtos</h1>
        </div>
        <Button asChild className="bg-white text-black hover:bg-zinc-200 uppercase tracking-widest text-xs h-11 px-5">
          <Link to="/admin/produtos/novo" data-testid="admin-new-product-btn"><Plus size={14} className="mr-2" /> Novo produto</Link>
        </Button>
      </div>

      <div className="border border-white/10 bg-[#0A0A0C] overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="text-xs uppercase tracking-widest text-zinc-500">
            <tr>
              <th className="text-left px-4 py-3 w-14"></th>
              <th className="text-left px-4 py-3">Nome</th>
              <th className="text-left px-4 py-3">SKU</th>
              <th className="text-right px-4 py-3">Preço</th>
              <th className="text-right px-4 py-3">Estoque</th>
              <th className="text-left px-4 py-3">Status</th>
              <th className="text-right px-4 py-3">Ações</th>
            </tr>
          </thead>
          <tbody>
            {prods.map((p) => {
              const img = (p.images || []).find((i) => i.is_primary) || (p.images || [])[0];
              return (
                <tr key={p.id} className="border-t border-white/5">
                  <td className="px-4 py-3">
                    <div className="h-12 w-10 bg-black border border-white/10 overflow-hidden">
                      {img ? <img src={fileUrl(img.path)} alt="" className="w-full h-full object-cover" /> : null}
                    </div>
                  </td>
                  <td className="px-4 py-3 text-white">{p.name}</td>
                  <td className="px-4 py-3 font-mono text-xs text-zinc-400">{p.sku}</td>
                  <td className="px-4 py-3 text-right font-display">
                    {p.sale_price ? (
                      <>
                        <div>{formatBRL(p.sale_price)}</div>
                        <div className="text-[11px] strike-price">{formatBRL(p.price)}</div>
                      </>
                    ) : (
                      formatBRL(p.price)
                    )}
                  </td>
                  <td className={`px-4 py-3 text-right ${p.stock < 5 ? "text-amber-400" : "text-zinc-300"}`}>{p.stock}</td>
                  <td className="px-4 py-3">
                    <span className={`text-[11px] uppercase tracking-wide ${p.active ? "text-emerald-400" : "text-zinc-500"}`}>{p.active ? "Ativo" : "Inativo"}</span>
                  </td>
                  <td className="px-4 py-3">
                    <div className="flex justify-end gap-2">
                      <Button asChild size="sm" variant="outline" className="bg-transparent border-white/15 text-white hover:bg-white/5 h-8 px-3">
                        <Link to={`/admin/produtos/${p.id}`} data-testid={`edit-product-${p.id}`}><Pencil size={14} /></Link>
                      </Button>
                      <Button size="sm" variant="outline" onClick={() => setDel(p)} className="bg-transparent border-red-500/40 text-red-300 hover:bg-red-500/10 h-8 px-3" data-testid={`delete-product-${p.id}`}>
                        <Trash2 size={14} />
                      </Button>
                    </div>
                  </td>
                </tr>
              );
            })}
            {prods.length === 0 && (
              <tr><td colSpan="7" className="px-4 py-16 text-center text-zinc-500">Nenhum produto cadastrado ainda. Clique em “Novo produto”.</td></tr>
            )}
          </tbody>
        </table>
      </div>

      <Dialog open={!!del} onOpenChange={(v) => !v && setDel(null)}>
        <DialogContent className="bg-[#0A0A0C] border-white/10 text-white">
          <DialogHeader>
            <DialogTitle>Excluir produto?</DialogTitle>
            <DialogDescription className="text-zinc-400">
              Tem certeza que deseja excluir “{del?.name}”? Esta ação não pode ser desfeita.
            </DialogDescription>
          </DialogHeader>
          <DialogFooter>
            <Button variant="outline" onClick={() => setDel(null)} className="bg-transparent border-white/15 text-white">Cancelar</Button>
            <Button onClick={doDelete} className="bg-red-600 text-white hover:bg-red-700" data-testid="confirm-delete-product">Excluir</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
